export const BIOFUEL_TO_REPORT_REQUEST = 'BiofuelToReportRequest';
export const ELECTRICITY_TO_REPORT_REQUEST = 'ElectricityToReportRequest';
export const STATISTICS_TRANSFER_REQUEST = 'StatisticsTransferRequest';

export const VDS_REQUEST_TYPES = [
  BIOFUEL_TO_REPORT_REQUEST,
  ELECTRICITY_TO_REPORT_REQUEST,
  STATISTICS_TRANSFER_REQUEST,
];
